/*
 * Inpired by https://laracasts.com/discuss/channels/vue/jwt-auth-with-vue-resource-interceptor
 */
import Vue from "vue"
import store from "../store"
import { api as configs } from "@/app/config"
import * as services from "../../domains/Auth/services"

export default (request, next) => {
	next((response) => {
		//
		if (response.status === 403) {
			// Skip storing token refresh requests
			if (request.url === configs.baseUrl + "refresh_token") {
				return Promise.reject(response)
			}
			// Request refresh token
			//
			return services
				.revokeToken()
				.then((response) => {
					if (response.data == undefined || response.data == "" || response.data == null) {
						window.location.reload()
					}

					store.dispatch("Auth/setToken", response.data) // Store refreshed token
					request.headers.map.Authorization = [`Bearer ${response.data}`]
					return Vue.http(request)
						.then((data) => {
							return Promise.resolve(data)
						})
						.catch((e) => {
							console.log(e)
							window.location.reload()
						})
					// services.loadUserData()
					//   .then(respo => {
					//     store.dispatch('Auth/setUser', respo.data)
					//     return Vue.http(request)
					//       .then(data => {
					//         return Promise.resolve(data)
					//       })
					//   })
					//   .catch(error => {
					//
					//     // Vue.$router.go({ name: 'auth.login' })
					//     Vue.router.go({ name: 'auth.login' })
					//   })
				})
				.catch((error) => {
					// Vue.$router.go({ name: 'auth.login' })
					window.location.reload()
				})
		}
	})
}
